import create from "zustand";

const UserStore = create((set) => ({
  users: [],
  setUsers: (data) => set((state) => ({ users: data })),
}));

export default UserStore;
